import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FlightReportDetailsComponent } from "@/components/reports/flight-report-details/flight-report-details.component";

@Component({
    standalone: true,
    selector: "app-report-submit",
    templateUrl: "./report-submit.component.html",
    imports: [FlightReportDetailsComponent],
})
export class ReportSubmitComponent implements OnInit {
    assessmentId: string | null = null;
    issueId: string | null = null;
    parentReportId: string | null = null;
    promotionId: string | null = null;
    returnTo: string | null = null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
    ) {}

    ngOnInit(): void {
        const p = this.route.snapshot.queryParams;
        this.assessmentId = p["assessmentId"] ?? null;
        this.issueId = p["issueId"] ?? null;
        this.parentReportId = p["parentReportId"] ?? null;
        this.promotionId = p["promotionId"] ?? null;
        this.returnTo = p["returnTo"] ?? null;
    }

    onClose(): void {
        this.router.navigateByUrl(this.returnTo ?? "/home/tasks");
    }
}
